import { msInventoryChangelog } from 'store/saga/entities/bound';

export const selectMsiChangelogState = state => state.venuePage.msiChangelog;

export const selectMsiChangelogEntityState = (state, { activeVenueId, selectedChangelogType, page }) => {
  const key = msInventoryChangelog.defaultKey(null, activeVenueId, selectedChangelogType, page);
  const { data: changelogData, loaded: isLoaded } = msInventoryChangelog.select(state, key);

  const { data: changelog, meta } = changelogData || {};
  const { totalCount } = meta || {};

  return { changelog, isLoaded, totalCount };
};
